import { InlineRangeCalendar } from "PFComponents/calendar/inline_calendar";
import { utc } from "PFCore/helpers/date";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import PropTypes from "prop-types";

import { ComponentPropTypes } from "../component_prop_types";

const InlineRangeCalendarWrapper = ({
  value,
  label,
  title,
  formattedTitle,
  onChange,
  qaId,
  style,
  error,
  required,
  disabled,
  className,
  variant,
  portalRef,
  tabIndex,
  inputRef
}) => {
  const { formatISODate, formatDatabaseDateTime } = useDateFormatter();
  return (
    <InlineRangeCalendar
      startDate={value && value.start_date && formatISODate(utc(value.start_date))}
      endDate={value && value.end_date && formatISODate(utc(value.end_date))}
      label={label}
      title={formattedTitle || title}
      qaId={qaId}
      required={required}
      error={error && Object.values(error)[0]}
      handleChange={(start, end) => {
        if (start === null && end === null) {
          // to handle clear, as the API does not allowed null values for start or end date
          onChange(null);
        } else {
          onChange({
            start_date: formatDatabaseDateTime(start),
            end_date: formatDatabaseDateTime(end)
          });
        }
      }}
      letClear
      disabled={disabled}
      portalRef={portalRef}
      variant={variant}
      inputFieldSetProps={{
        inputClassName: className
      }}
      tabIndex={tabIndex}
      style={style}
      inputRef={inputRef}
    />
  );
};

InlineRangeCalendarWrapper.propTypes = {
  ...ComponentPropTypes,
  value: PropTypes.object,
  error: PropTypes.object
};

export default InlineRangeCalendarWrapper;
